import { Skeleton, Stack } from "@chakra-ui/react";
import React from "react";

function SkeletonChat() {
  return (
    <Stack>
      <Skeleton startColor="gray.250" endColor="gray.300" height="18px" />
      <Skeleton startColor="gray.250" endColor="gray.300" height="18px" />
      <Skeleton startColor="gray.250" endColor="gray.300" height="18px" />
      <Skeleton startColor="gray.250" endColor="gray.300" height="18px" />
      <Skeleton startColor="gray.250" endColor="gray.300" height="18px" />
      <Skeleton startColor="gray.250" endColor="gray.300" height="18px" />
      <Skeleton startColor="gray.250" endColor="gray.300" height="18px" />
      <Skeleton startColor="gray.250" endColor="gray.300" height="18px" />
      <Skeleton startColor="gray.250" endColor="gray.300" height="18px" />
      <Skeleton startColor="gray.250" endColor="gray.300" height="18px" />
    </Stack>
  );
}

export default SkeletonChat;
